export const tokenTTLSeconds = 60 * 60 * 24
export const refreshTokenTTLSeconds = 60 * 60 * 24 * 30